/**
 *  @class
 *  @function ThemeFooter
 */

if (!customElements.get('theme-footer')) {
  class ThemeFooter extends HTMLElement {
    constructor() {
      super();
      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      this.accordions = this.querySelectorAll('details');

      // Call onResize directly to set initial state based on window size
      this.onResize();

      // Add resize event listener
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      // Remove resize event listener when element is removed
      window.removeEventListener('resize', this.onResize);
    }

    onResize() {
      this.accordions.forEach((accordion) => {
        if (window.innerWidth > 768) {
          accordion.setAttribute('open', '');
        } else {
          accordion.removeAttribute('open');
        }
      });
    }
  }

  customElements.define('theme-footer', ThemeFooter);
}


//get in touch popup form 

document.addEventListener('click', function (e) {
  const trigger = e.target.closest('[data-open-contact-modal]');
  if (trigger) {
    const modal = document.getElementById('contact-us-modal');
    const email = trigger.getAttribute('data-recipient-email');
    document.getElementById('contact-modal-recipient').textContent = email;
    sessionStorage.setItem('contactModalRecipient', email); // NEW: persist across reload
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  if (e.target.closest('[data-close-contact-modal]')) {
    const modal = document.getElementById('contact-us-modal');
    modal.hidden = true;
    document.body.style.overflow = '';
  }
});

// NEW: reopen the modal after a form submit reload
document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('contact-us-modal');
  if (!modal) return;

  const reopenMarker = modal.querySelector('[data-contact-modal-reopen]');
  if (reopenMarker) {
    modal.hidden = false;
    document.body.style.overflow = 'hidden';

    const savedEmail = sessionStorage.getItem('contactModalRecipient');
    const recipientEl = document.getElementById('contact-modal-recipient');
    if (savedEmail && recipientEl) {
      recipientEl.textContent = savedEmail;
    }
  }
});